import { render, staticRenderFns } from "./DocBlue.vue?vue&type=template&id=b7bc68be"
import script from "./DocBlue.vue?vue&type=script&lang=js"
export * from "./DocBlue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports